/**
 * life-x (LIFE X 重複チェック) の公開ルート定義
 *
 * @see docs/計画/2026-05-09-ICpochipochi-漏れ抽象化.md L-A3
 */

export const LIFE_X_PUBLIC_PATHS = {
  pages: [] as const,
  apis: ['/api/life-x/check-email'] as const,
} as const
